import { createReducer, on, Action } from '@ngrx/store';
import { IUserRootObject } from 'src/app/models/user';
import * as UserDetailsActions from './user.action';
import { IPermission } from 'src/app/models/map';

export const initialState: IUserRootObject = {
};

export const reducer = createReducer(initialState,
  on(UserDetailsActions.SuccessGetUserDetailsApiAction, (state, { userDetails }) => {
    const obj: IUserRootObject = {
      payload: {
        ...userDetails.payload,
        lastScannedSiteId: state?.payload?.lastScannedSiteId
      }
    };
    return obj;
  }),
  on(UserDetailsActions.updateLastScannedSiteAction, (state, { siteId }) => {
    const obj: IUserRootObject = {
      payload: {
        ...state.payload,
        lastScannedSiteId: siteId
      }
    };
    return obj;
  }),
  on(UserDetailsActions.ErrorGetUserDetailsApiAction, (state, error) => ({ ...state, error })),
  on(UserDetailsActions.SuccessPostUserDetailsApiAction, (state, { userDetails }) => ({ ...state, message: undefined, ...userDetails })),
  on(UserDetailsActions.SuccessGetUserRecentDetailsApiAction, (state, { recentCheckIn }) => {
    const obj: IUserRootObject = {
      payload: {
        ...state.payload,
        recentCheckIns: recentCheckIn
      }
    };
    return obj;
  }),
  on(UserDetailsActions.SuccessGetUserActiveCheckinDetailsApiAction, (state, { activeCheckIn }) => {
    const obj: IUserRootObject = {
      payload: {
        ...state.payload,
        activeCheckIn: activeCheckIn.activeCheckIn !== undefined ? activeCheckIn.activeCheckIn : {},
        proxyActiveCheckIns: activeCheckIn.proxyActiveCheckIns
      }
    };
    return obj;
  })
);
export function UserDetailsReducer(state: IUserRootObject | undefined, action: Action) {
  return reducer(state, action);
}

export const tabInitialState = 'Self';
export const tabReducer = createReducer(tabInitialState,
  on(UserDetailsActions.SetUserTabSelection, (state, { tabType }) => tabType));

export function SelectedTabReducer(state: string | undefined, action: Action) {
  return tabReducer(state, action);
}

export const HistoryInit = false;
export const historyReducer = createReducer(HistoryInit,
  on(UserDetailsActions.SetUserHistorySelection, (state, { value }) => value));

export function HistoryReducer(state: boolean | undefined, action: Action) {
  return historyReducer(state, action);
}
export const previousUrl = '';
export const urlReducer = createReducer(previousUrl,
  on(UserDetailsActions.SetPreviousUrl, (state, { url }) => url));

export function URLReducer(state: string | undefined, action: Action) {
  return urlReducer(state, action);
}

export const requestUrlReducer = createReducer(previousUrl,
  on(UserDetailsActions.SetRequestUrl, (state, { url }) => url));

export function RequestURLReducer(state: string | undefined, action: Action) {
  return requestUrlReducer(state, action);
}

const addNewInit = false;
export const addNewReducer = createReducer(addNewInit,
  on(UserDetailsActions.SetAddNewAction, (state, { value }) => value));

export function AddNewReducer(state: boolean | undefined, action: Action) {
  return addNewReducer(state, action);
}

// User Level Permission reducer
export const initialPermState: IPermission[] = [];

const permissionReducer = createReducer(
  initialPermState,
  on(UserDetailsActions.SetUserLevelPermissions, (state: IPermission[], { permission }) => permission),

);

export function UserPermissionReducer(state: IPermission[] | undefined, action: Action) {
  return permissionReducer(state, action);
}
